import * as angular from "angular";
import {
    NavianceSchoolWithProducts,
    NavianceSchoolWithProductsData
} from "../../models/school/naviance-school-with-products.model";
import {History} from "../../models/history.model";
import {ApiUrl} from "../../models/app-config.model";
import {CleverSchool} from "../../models/school/clever-school.model";
import * as moment from "moment-timezone";
import {AddressService} from "../address/address.service";

export interface DistrictService {
    getNavianceSchools: (districtId: string) => angular.IPromise<NavianceSchoolWithProducts[]>;
    getCleverSchools: (districtId: string) => angular.IPromise<CleverSchool[]>;
    getHistory: (districtId: string) => angular.IPromise<History[]>;
}

interface NavianceSchoolsWithProductsResponse { data: { navianceSchools: NavianceSchoolWithProductsData[] }; };
interface CleverSchoolsResponse { data: { cleverSchools: CleverSchool[] }; };
interface HistoryResponse { data: { history: History[] }; };

/* @ngInject */
export function districtService(API_URL: ApiUrl, $http: angular.IHttpService, $q: angular.IQService,
    addressService: AddressService): DistrictService {
    let handleErrorResponse = (errorResponse): any => {
        if (errorResponse && errorResponse.status === 404) {
            return [];
        }
        return $q.reject(errorResponse);
    };

    return {
        getNavianceSchools: (districtId: string): angular.IPromise<NavianceSchoolWithProducts[]> => {
            return $http.get(`${API_URL.navianceSchools.replace(/\:districtId/, districtId)}`)
                .then((response: NavianceSchoolsWithProductsResponse) => {
                    return response.data.navianceSchools.map((navianceSchool) => {
                        return new NavianceSchoolWithProducts(navianceSchool);
                    });
                }, handleErrorResponse);
        },
        getHistory: (districtId: string): angular.IPromise<History[]> => {
            return $http.get(`${API_URL.history.replace(/\:districtId/, districtId)}`)
                .then((response: HistoryResponse) => {
                    response.data.history.forEach(row => {
                        row.matchedDate = (moment as any).tz(row.matched, "UTC").local().format("MMM DD YYYY hh:mm A");
                        row.navianceSchoolDisplay =
                            `${row.navianceSchool.institutionName}

${addressService.getNavianceSchoolAddressLine(row.navianceSchool)}
${addressService.getNavianceSchoolCityStateZip(row.navianceSchool)}

NCES ID: ${row.navianceSchool.ncesId}`;

                        row.cleverSchoolDisplay =
                            `${row.cleverSchool.name}
                
${addressService.getCleverSchoolAddress(row.cleverSchool)}
${addressService.getCleverSchoolCityStateZip(row.cleverSchool)}

NCES ID: ${row.cleverSchool.ncesId}`;
                        });
                    return response.data.history;
                }, handleErrorResponse);
        },
        getCleverSchools: (districtId: string): angular.IPromise<CleverSchool[]> => {
            return $http.get(`${API_URL.cleverSchools.replace(/\:districtId/, districtId)}`)
                .then((response: CleverSchoolsResponse) => {
                    return response.data.cleverSchools;
                }, handleErrorResponse);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/district/district.service.ts